import React from "react";
import {UtmsList} from "../../models/utms/UtmsListModel";
import {UtmsListViewState} from "../../components/utms/list/UtmsListViewState";
import async from "../../components/Async";
import IosPaper from "react-ionicons/lib/IosPaper";
import {buildUtmsColumns} from "../../components/utms/list/UtmsListView";
import {RouterState, RouterStore} from "mobx-state-router";
import {CreateUtmState} from "../../components/utms/create/CreateUtmState";
import {EditUtmState} from "../../components/utms/edit/EditUtmState";
import {ModalState} from "../../components/elements/modal/GenericModal";
import {Utm} from "../../models/utms/UtmModel";
import {onSnapshot, types} from "mobx-state-tree";
import {checkUserPermissions} from "../../utils/requiredRolesCheck";
import CodeParamsStore from "../../stores/domain/parameters/CodeParamsStore";
import GS1ParamsStore from "../../stores/domain/parameters/GS1ParamStore";
import {filterSessionConstants} from "../../utils/constants";
import {registerInitialFilterSnapshot} from "../../utils/filterStorage";

// Page Async Reference, for lazy loading in UI
const UtmsListHome = async(()=> import("../../pages/utms/UtmsListHome"));
const CreateUtmHome = async(()=> import("src/pages/utms/CreateUtmHome.js"));
const EditUtmHome = async(()=> import("src/pages/utms/EditUtmHome.js"));
export const viewMap = {
  utms: <UtmsListHome/>,
  createUtm: <CreateUtmHome/>,
  editUtm: <EditUtmHome/>
};
export const routeDefinitions = [
  {
    path: "utms",
    name: "UTM",
    icon: IosPaper,
    component: UtmsListHome,
    children: null,
    // featureFlagRequired: "cmp_ui_utms"
  },
];
export const routeTransitions = [
  {
    name: "utms",
    pattern: "/configs/utms",
    onEnter: async (
      fromState: RouterState,
      toState: RouterState,
      routerStore: RouterStore
    ) => {
      const {rootStore} = routerStore.options;
      const groupSelectState = rootStore.rootUiStore.groupSelectStore;
      const tagSelectStore = rootStore.rootUiStore.tagSelectStore;
      const utmStore = rootStore.domainStore.utmStore
      tagSelectStore?.tagStore?.init(); //reset tags
      tagSelectStore?.setSelectedTags([]);
      const utmsList = UtmsList.create({
        store:utmStore
      });
      const advFilterSelectState = rootStore.rootUiStore.advFilterSelectState;
      const codeOwnerFilterSelectState = rootStore.rootUiStore.codeOwnerFilterSelectState;
      const dimensionSelectViewState = rootStore.rootUiStore.dimensionSelectViewState;
      const tagFilterSelectState = rootStore.rootUiStore.tagFilterSelectState;
      const groupFilterSelectState = rootStore.rootUiStore.groupFilterSelectState;
      advFilterSelectState.reset();
      codeOwnerFilterSelectState.reset();
      dimensionSelectViewState.reset();
      tagFilterSelectState.reset();
      groupFilterSelectState.reset();
      const modalState = ModalState.create({});
      const utmsListViewState = UtmsListViewState.create({
        listModel: utmsList,
        groupSelectStore: groupSelectState,
        tagSelectStore:tagSelectStore,
        modalStore: modalState,
        advFilterSelectState: advFilterSelectState,
        codeOwnerFilterSelectState: codeOwnerFilterSelectState,
        dimensionSelectViewState: dimensionSelectViewState,
        tagFilterSelectState: tagFilterSelectState,
        groupFilterSelectState: groupFilterSelectState
    });
      registerInitialFilterSnapshot(utmsListViewState, filterSessionConstants.CONFIG_SESSION_STORAGE_KEY);
      utmsListViewState.loadColumnsFromSession();
      utmsListViewState.setColumns(buildUtmsColumns(routerStore, utmsListViewState))
      await rootStore.rootUiStore.attachPageState("utmsListViewState", utmsListViewState);
      utmsListViewState?.loadFiltersFromSessionStorage();
      utmsListViewState.refresh();
      await  rootStore.rootUiStore.utmsListViewState?.getFilters();

    },
    onExit: async (
      fromState: RouterState,
      toState: RouterState,
      routerStore: RouterStore
    ) => {
// const {rootStore} = routerStore.options;
    }
  },
  {
    name: 'createUtm',
    pattern: '/configs/utms/create',
    beforeEnter: checkUserPermissions,
    onEnter: async (
      fromState: RouterState,
      toState: RouterState,
      routerStore: RouterStore
    ) => {
      const {rootStore} = routerStore.options;
      let {queryParams} = toState;
      const groupSelectStore = rootStore.rootUiStore.groupSelectStore;

      const tagSelectStore = rootStore.rootUiStore.tagSelectStore;
      const dimensionsMultiSelectState = rootStore.rootUiStore.dimensionsMultiSelectState;
      const tenantStore = rootStore.domainStore.tenantStore;
      groupSelectStore?.selectDefaultGroup(tenantStore.defaultGroupUuid);

      const codeParamsStore = CodeParamsStore.create({
        storeUuid: "codeParamsStore"
      });
      const gs1ParamsStore = GS1ParamsStore.create({
        storeUuid: "gs1"
      })
      const extendedDataSelectStore = rootStore.rootUiStore.extendedDataSelectStore;
      await rootStore.rootUiStore.attachPageState('codeParamsStore', codeParamsStore)
      await rootStore.rootUiStore.attachPageState('gs1ParamsStore', gs1ParamsStore)
      const utmParameterSelectStore = rootStore.rootUiStore.utmParameterSelectState;
      utmParameterSelectStore.setCodeParamsTypeSelectState(rootStore.rootUiStore.codeParamsStore);
      utmParameterSelectStore.setGS1ParamsTypeSelectState(rootStore.rootUiStore.gs1ParamsStore);
      utmParameterSelectStore.setUtmExtedDataSelectState(extendedDataSelectStore);
      extendedDataSelectStore.store.init();

      const snapShot = (queryParams.q)?rootStore.rootUiStore?.globalCache[`clone-utm:${queryParams.q}`]:null
      const snapShotUtmUuid = snapShot?.uuid;
      let utm;
      let createUtmState;

      if (snapShot && snapShotUtmUuid){
        const utmStore = rootStore.rootUiStore?.utmSelectState?.store
        utm = await utmStore?.getUtm(snapShotUtmUuid);
        groupSelectStore?.selectGroup(snapShot?.owner?.groupUuid);
        tagSelectStore?.setSelectedTags(snapShot.tags);
        dimensionsMultiSelectState.init();
        dimensionsMultiSelectState.setDefaults();
        dimensionsMultiSelectState.getListOnGroup(snapShot?.owner?.groupUuid);

        createUtmState = CreateUtmState.create({
          groupSelectStore: groupSelectStore,
          tagSelectStore: tagSelectStore,
          utmParameterSelectState: utmParameterSelectStore,
          isExclusivelyGroupOwned: utm.isExclusivelyGroupOwned,
          utm: Utm.create({
            uuid:"createUtm",
            name: "",
            campaign: utm.campaign,
            source: utm.source,
            medium: utm.medium,
            term: utm.term,
            content: utm.content,
            campaignSelectValue : utm?.utmParametersConfigs?.campaignSelectValue,
            sourceSelectValue : utm?.utmParametersConfigs?.sourceSelectValue,
            mediumSelectValue : utm?.utmParametersConfigs?.mediumSelectValue,
            termSelectValue : utm?.utmParametersConfigs?.termSelectValue,
            contentSelectValue : utm?.utmParametersConfigs?.contentSelectValue
          }),
          dimensionsMultiSelectStore: dimensionsMultiSelectState,
        })
      } else {
        tagSelectStore?.tagStore?.init(); //reset tags
        tagSelectStore?.setSelectedTags([]);
        dimensionsMultiSelectState.init();
        dimensionsMultiSelectState.setDefaults();
        dimensionsMultiSelectState.getListOnGroup(groupSelectStore.selectedGroup);
        createUtmState = CreateUtmState.create({
          groupSelectStore:groupSelectStore,
          tagSelectStore:tagSelectStore,
          utmParameterSelectState: utmParameterSelectStore,
          utm: Utm.create({uuid:"createUtm"}),
          dimensionsMultiSelectStore: dimensionsMultiSelectState
        })

      }

      await rootStore.rootUiStore.attachPageState('createUtmState', createUtmState);
      createUtmState?.utmParameterSelectState.fetchAllParameters()
      snapShot && snapShotUtmUuid && createUtmState.hydrateDimension(utm?.owner?.dimensions);
    },
    onExit: async (
      fromState: RouterState,
      toState: RouterState,
      routerStore: RouterStore
    ) => {
      const {rootStore} = routerStore.options;
    }
  },
  {
    name: 'editUtm',
    pattern: '/configs/utms/edit/:uuid',
    beforeEnter: checkUserPermissions,
    onEnter: async (
      fromState: RouterState,
      toState: RouterState,
      routerStore: RouterStore
    ) => {
      const {params, queryParams: {isEditable: isEditableStr}} = toState
      const isEditable = isEditableStr !== 'false';
      const isView = isEditable !== undefined ? !isEditable : false

      const {rootStore} = routerStore.options;

      const codeParamsStore = CodeParamsStore.create({
        storeUuid: "codeParamsStore"
      });
      const gs1ParamsStore = GS1ParamsStore.create({
        storeUuid: "gs1"
      })
      const extendedDataSelectStore = rootStore.rootUiStore.extendedDataSelectStore;
      await rootStore.rootUiStore.attachPageState('codeParamsStore', codeParamsStore)
      await rootStore.rootUiStore.attachPageState('gs1ParamsStore', gs1ParamsStore)
      const utmParameterSelectStore = rootStore.rootUiStore.utmParameterSelectState;
      utmParameterSelectStore.setCodeParamsTypeSelectState(rootStore.rootUiStore.codeParamsStore);
      utmParameterSelectStore.setGS1ParamsTypeSelectState(rootStore.rootUiStore.gs1ParamsStore);
      utmParameterSelectStore.setUtmExtedDataSelectState(extendedDataSelectStore);
      extendedDataSelectStore.store.init();

      const groupSelectState = rootStore.rootUiStore.groupSelectStore;
      const tagSelectStore = rootStore.rootUiStore.tagSelectStore;
      const dimensionsMultiSelectState = rootStore.rootUiStore.dimensionsMultiSelectState;
      dimensionsMultiSelectState.init();
      dimensionsMultiSelectState.setDefaults();

      const editUtmState = EditUtmState.create({
        uuid:params.uuid,
        groupSelectStore: groupSelectState,
        tagSelectStore: tagSelectStore,
        utmParameterSelectState: utmParameterSelectStore,
        utm: Utm.create({uuid:"createUtm"}),
        dimensionsMultiSelectStore: dimensionsMultiSelectState,
        isView: isView
      });

      await rootStore.rootUiStore.attachPageState('editUtmState', editUtmState)
      editUtmState?.utmParameterSelectState.fetchAllParameters()
      await editUtmState.fetchWithID()
    }
  },
]
